// extracted by mini-css-extract-plugin
var _1 = "PublicSidebar-module__animateUploadProgressBarWidth--hHWle";
var _2 = "PublicSidebar-module__animatedBackground--CEPig";
var _3 = "PublicSidebar-module__container--ns_7l";
var _4 = "PublicSidebar-module__controls--v2pH2";
var _5 = "PublicSidebar-module__icon--b0SJs";
var _6 = "PublicSidebar-module__isAtBottom--YEKQ2";
var _7 = "PublicSidebar-module__isFloating--bCKQE";
var _8 = "PublicSidebar-module__isScrolled--WNCYH";
var _9 = "PublicSidebar-module__searchBar--B4ctJ";
var _a = "PublicSidebar-module__searchBarContainer--C3zC9";
var _b = "PublicSidebar-module__searchIcon--ygNob";
var _c = "PublicSidebar-module__sections--xvwNT";
var _d = "PublicSidebar-module__shortcut--bc8_1";
var _e = "PublicSidebar-module__sidebarToggleButton--irS_B";
var _f = "PublicSidebar-module__sidebarToggleButtonContainer--vaSMl";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "controls", _5 as "icon", _6 as "isAtBottom", _7 as "isFloating", _8 as "isScrolled", _9 as "searchBar", _a as "searchBarContainer", _b as "searchIcon", _c as "sections", _d as "shortcut", _e as "sidebarToggleButton", _f as "sidebarToggleButtonContainer" }
